import React, { useState, useEffect } from "react";

interface PipelineSummary {
  new: number;
  contacted: number;
  qualified: number;
  proposal: number;
  won: number;
  lost: number;
  total: number;
}

interface CRMPipelineViewProps {
  onRefresh: () => void;
}

const CRMPipelineView: React.FC<CRMPipelineViewProps> = ({ onRefresh }) => {
  const [summary, setSummary] = useState<PipelineSummary>({
    new: 0,
    contacted: 0,
    qualified: 0,
    proposal: 0,
    won: 0,
    lost: 0,
    total: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSummary();
  }, []);

  const fetchSummary = async () => {
    try {
      setLoading(true);
      const response = await fetch("/api/crm/pipeline/summary");
      if (!response.ok) throw new Error("Failed to fetch pipeline summary");
      const data = await response.json();
      setSummary(data);
    } catch (err) {
      console.error("Failed to load pipeline summary:", err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="pipeline-summary">
        {[1, 2, 3, 4, 5, 6].map((i) => (
          <div key={i} className="pipeline-card" style={{ opacity: 0.5 }}>
            <div className="pipeline-card-label">Loading...</div>
            <div className="pipeline-card-count">-</div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="pipeline-summary">
      <div className="pipeline-card new">
        <div className="pipeline-card-label">New</div>
        <div className="pipeline-card-count">{summary.new}</div>
      </div>
      <div className="pipeline-card contacted">
        <div className="pipeline-card-label">Contacted</div>
        <div className="pipeline-card-count">{summary.contacted}</div>
      </div>
      <div className="pipeline-card qualified">
        <div className="pipeline-card-label">Qualified</div>
        <div className="pipeline-card-count">{summary.qualified}</div>
      </div>
      <div className="pipeline-card proposal">
        <div className="pipeline-card-label">Proposal</div>
        <div className="pipeline-card-count">{summary.proposal}</div>
      </div>
      <div className="pipeline-card won">
        <div className="pipeline-card-label">Won 🎉</div>
        <div className="pipeline-card-count">{summary.won}</div>
      </div>
      <div className="pipeline-card lost">
        <div className="pipeline-card-label">Lost</div>
        <div className="pipeline-card-count">{summary.lost}</div>
      </div>
    </div>
  );
};

export default CRMPipelineView;
